var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReloj(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 768",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".reloj_svg__st0{fill:#b4b4b4}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "reloj_svg__st0",
    d: "M882.4 405.4h-19.3c0 69.5-28.1 132.2-73.6 177.8-45.6 45.5-108.3 73.6-177.8 73.6-69.5 0-132.2-28.1-177.8-73.6-45.5-45.6-73.6-108.3-73.6-177.8 0-69.5 28.1-132.2 73.6-177.8 45.6-45.5 108.3-73.6 177.8-73.6 69.5 0 132.2 28.1 177.8 73.6 45.5 45.6 73.6 108.3 73.6 177.8h38.6c0-80.1-32.5-152.7-85-205.2-52.4-52.5-125.1-85-205.2-85s-152.7 32.5-205.2 85c-52.5 52.4-85 125.1-85 205.2s32.5 152.7 85 205.2c52.4 52.5 125.1 85 205.2 85s152.7-32.5 205.2-85c52.5-52.4 85-125.1 85-205.2h-19.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "reloj_svg__st0",
    d: "M730.9 407.9l-113.2 12.2v-192c0-12.4-10-22.4-22.4-22.4s-22.4 10-22.4 22.4V445c0 6.3 2.7 12.4 7.4 16.6 4.7 4.2 11.1 6.3 17.3 5.6l137.9-14.9c12.3-1.3 21.2-12.4 19.8-24.6-1.1-12.3-12.1-21.1-24.4-19.8z"
  })));
}

export default SvgReloj;